import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { AppErrorBoundary } from 'components/AppErrorBoundary';
import { AppLoader } from 'components/AppLoader';
import { WormholeFabric } from 'components/Wormhole';
import { queryClient } from 'domains/data';
import MixPanelProvider from 'utils/hooks/useMixPanel';
import { initializeSentry } from './utils/sentry';
import { ToastProvider } from '@expressable/syntax-ds';

const Router = React.lazy(() => import('router'));

initializeSentry();

export default function App(): JSX.Element {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <AppErrorBoundary>
          <ToastProvider>
            <MixPanelProvider>
              <AppLoader>
                <WormholeFabric>
                  <Router />
                </WormholeFabric>
              </AppLoader>
            </MixPanelProvider>
          </ToastProvider>
        </AppErrorBoundary>
      </QueryClientProvider>
    </HelmetProvider>
  );
}
